import React from 'react';
import { Stack, Text, themeVars, Button, AlertInline } from '@eds-web/react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useInterviewFlow } from '../../hooks/useInterviewFlow';
import { useRetakePrizeNavigation } from '../../hooks/useRetakePrizeNavigation';
import { selectTaxProfileState } from '../../selectors/tax.selector';
import { useFirstPrizeWithInterviewUrl } from '../../hooks/useFirstPrizeWithInterviewUrl';

export const RetakeProfile = () => {
    const { t } = useTranslation();
    const { isUnder18, retakeWithFirstPrize } = useFirstPrizeWithInterviewUrl();
    const taxProfileState = useSelector(selectTaxProfileState);
    const { handleRetakeButtonClick, firstPrizeWithTaxInterviewUrl } = useRetakePrizeNavigation();

    const { handleButtonClick } = useInterviewFlow({
        isRetake: true
    });

    const isButtonDisabled = !taxProfileState?.retakeAvailable && !firstPrizeWithTaxInterviewUrl;

    const handleRetakeClick = () => {
        if (retakeWithFirstPrize) {
            handleRetakeButtonClick();
            return;
        }
        handleButtonClick(!isUnder18);
    };

    return (
        <Stack gap={32}>
            <Stack gap={16}>
                <Text variant={'headingLG'}>{t('epic.esport.profile.retake.title')}</Text>
                <Stack gap={16}>
                    <Text
                        variant={'paragraphMD'}
                        style={{ color: themeVars.color.transparent.light['065'] }}
                    >
                        {t('epic.esport.profile.retake.info')}
                    </Text>
                    <AlertInline
                        status={'warning'}
                        message={t('epic.esport.profile.retake.warning')}
                    />
                </Stack>
            </Stack>
            <div>
                <Button onClick={handleRetakeClick} disabled={isButtonDisabled}>
                    {!taxProfileState?.retakeAvailable && firstPrizeWithTaxInterviewUrl
                        ? t('epic.esport.actions.startTaxInterview')
                        : t('epic.esport.profile.retakeInterview')}
                </Button>
            </div>
        </Stack>
    );
};
